import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const ItDevelopment = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="93" viewBox="0 0 85 93" width="85" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M78.36 19.08v35.75a7.5 7.5 0 0 1-7.48 7.49l-53.98.75a7.4 7.4 0 0 1-6.1-3.18q-.06-.03-.08-.06l-.02-.07-3.16-4.62a8 8 0 0 0 1.96 1.63 7 7 0 0 0 3.8 1.06h54.73c4.13 0 6.74-4.1 6.74-8.24V13.83a6 6 0 0 0-.12-1.2 7 7 0 0 0-1.04-2.8L77 14.76a7.5 7.5 0 0 1 1.36 4.32z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M74.78 21.8v27.8c0 4.13-2.6 8.24-6.75 8.24H13.3l-.67-.05a7.6 7.6 0 0 1-5.09-2.65l-.1-.13a7.5 7.5 0 0 1-1.63-4.66V21.8z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M74.78 13.83v7.98H5.81V14.6a7.5 7.5 0 0 1 7.49-7.5l53.98-.74c2.48 0 4.7 1.21 6.05 3.08l.29.4c.52.83.9 1.78 1.04 2.8q.12.57.12 1.2Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path d="M14.24 17.66a2.89 2.89 0 1 0 0-5.78 2.89 2.89 0 0 0 0 5.78Z" fill={shades.primary.medium} />
      <path d="M23.72 17.66a2.89 2.89 0 1 0 0-5.78 2.89 2.89 0 0 0 0 5.78Z" fill={shades.secondary.medium} />
      <path d="M33.21 17.66a2.89 2.89 0 1 0 0-5.78 2.89 2.89 0 0 0 0 5.78Z" fill={shades.white} />
      <path className={strokeStyle} d="m10.8 59.9-.03.02-.05-.08.07.07Z" strokeWidth={strokeWidth} />
      <path d="M49.37 33.77v12.1h-6.05v-6.05h-6.06v6.06h-6.05V33.77z" fill={shades.black} />
      <path
        className={strokeStyle}
        d="M61.07 75.88a2.75 2.75 0 0 1-.45 3.85l-6.8 5.45a2.7 2.7 0 0 1-3.8-.43l-5.78-7.2a.9.9 0 0 0-1.27-.13l-6.11 4.9a2.73 2.73 0 0 1-4.33-1.36L19.57 36.8c-.23-.77.6-1.44 1.3-1.03l40.3 22.29a2.7 2.7 0 0 1 .38 4.48l-6.1 4.9a.9.9 0 0 0-.15 1.28z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M56.33 70.15a2.75 2.75 0 0 1-.45 3.85l-6.8 5.44a2.7 2.7 0 0 1-3.8-.42l-5.78-7.2a.9.9 0 0 0-1.27-.13l-6.11 4.9a2.73 2.73 0 0 1-4.33-1.36L14.83 31.05c-.23-.76.6-1.44 1.3-1.02l40.3 22.29a2.7 2.7 0 0 1 .38 4.48l-6.11 4.9a.9.9 0 0 0-.14 1.28z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
